"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var search_preset_service_1 = require("../../../services/search-preset.service");
var user_service_1 = require("../../../services/user.service");
var constants_1 = require("../../../constants");
var lodash_1 = __importDefault(require("lodash"));
var rxjs_1 = require("rxjs");
var core_2 = require("@uirouter/core");
var SearchPresetsComponent = /** @class */ (function () {
    function SearchPresetsComponent(searchPresetService, userService, stateService) {
        this.searchPresetService = searchPresetService;
        this.userService = userService;
        this.stateService = stateService;
        this.visible = false;
        this.visibleChange = new core_1.EventEmitter();
        this.isSltUser = false;
        this.searchPresets = [];
        this.userPresets = [];
        this.dealerPresets = [];
        this.commonPresets = [];
        this.searchPresetTypes = constants_1.SearchPresetTypes;
        this.subscriptionAggregator = new rxjs_1.Subscription();
    }
    SearchPresetsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getUserProfile()
            .then(function (userProfile) { return _this.isSltUser = userProfile.isSltUser; });
    };
    SearchPresetsComponent.prototype.ngOnDestroy = function () {
        this.subscriptionAggregator.unsubscribe();
    };
    SearchPresetsComponent.prototype.toggleSearchPresets = function () {
        this.visible = !this.visible;
        if (this.visible) {
            this.busy = this.getSearchPresets();
            this.subscriptionAggregator.add(this.busy);
        }
        this.visibleChange.emit(this.visible);
    };
    SearchPresetsComponent.prototype.getSearchPresets = function () {
        var _this = this;
        return rxjs_1.from(this.searchPresetService.getSearchPresets())
            .subscribe(function (searchPresetData) {
            _this.setSearchPresets(searchPresetData);
        });
    };
    SearchPresetsComponent.prototype.setSearchPresets = function (searchPresetData) {
        this.searchPresets = searchPresetData.sort(this.byDescSearchConditionID);
        this.userPresets = this.searchPresets.filter(this.byGroupType(this.searchPresetTypes.user));
        this.dealerPresets = lodash_1.default.uniqBy(this.searchPresets.filter(this.byGroupType(this.searchPresetTypes.dealer)), 'userSearchConditionID');
        this.commonPresets = this.searchPresets.filter(this.byGroupType(this.searchPresetTypes.common));
    };
    SearchPresetsComponent.prototype.byGroupType = function (groupType) {
        return function (searchPreset) {
            return searchPreset.userSearchConditionGroupType === groupType;
        };
    };
    SearchPresetsComponent.prototype.byDescSearchConditionID = function (item1, item2) {
        if (item1.userSearchConditionID > item2.userSearchConditionID)
            return -1;
        if (item1.userSearchConditionID < item2.userSearchConditionID)
            return 1;
        return 0;
    };
    SearchPresetsComponent.prototype.navigate = function (presetId) {
        this.visible = false;
        if (this.stateService.params.presetId == presetId && !this.stateService.params.recentActivity) {
            this.stateService.reload();
        }
        else {
            this.stateService.go('search.form', { presetId: presetId, recentActivity: null }, { reload: 'search.form', inherit: false });
        }
    };
    return SearchPresetsComponent;
}());
exports.SearchPresetsComponent = SearchPresetsComponent;
